import "./HomeChapterDivider.css";

/** Section break between homepage chapters: a hairline crossed by a four-point
    star in the brand pastels, with the chapter's title set small beneath it. */
export default function HomeChapterDivider({ id, title }) {
  return (
    <header className="home-chapter">
      <div className="home-chapter-rule" aria-hidden="true">
        <span />
        <svg viewBox="0 0 24 24" width="18" height="18">
          <defs>
            <linearGradient id="home-chapter-star-fill" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#8fd3ff" />
              <stop offset="50%" stopColor="#d9f99d" />
              <stop offset="100%" stopColor="#fed7aa" />
            </linearGradient>
          </defs>
          <path
            fill="url(#home-chapter-star-fill)"
            d="M12 0C12.7 7.6 16.4 11.3 24 12C16.4 12.7 12.7 16.4 12 24C11.3 16.4 7.6 12.7 0 12C7.6 11.3 11.3 7.6 12 0Z"
          />
        </svg>
        <span />
      </div>
      <h2 id={id}>{title}</h2>
    </header>
  );
}
